import React from 'react';
import { useNavigate } from 'react-router-dom'; 
import TeacherOld from '../../Assets/teacherOld.png';
import './TeacherSignin.css';

function TeacherSignin() {
  const navigate = useNavigate();

  const handleApplyClick = () => {
    navigate('/become-a-teacher');
  }
  
  return (
    <div className='teacher-signin-container'>
      <div className='teacher-signin-content'>
        <div className='teacher-image-wrapper'>
          <img src={TeacherOld} alt="Teacher teaching students" className="teacher-image" />
        </div>
        <div className='teacher-signin-info'>
          <span className="career-badge">Build Your Career</span>
          <h1 className="signin-title">
            Become an <span className="highlight">Instructor</span>
          </h1>
          <p className='signin-description'>
            Join BeyondSchools as an instructor and share your expertise with a global audience. 
            Inspire learners while building your teaching career on our innovative platform.
          </p>
          <button className="apply-button" onClick={handleApplyClick}>
            Apply Now
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
}

export default TeacherSignin;